import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Cluster } from '../ui/Layout';

// SettingsSection (P16 §4) — the one settings-screen template: title, description,
// optional audit link (P08-B seam — filtered audit view arrives with the audit
// UI), an action slot, and content. Visual consistency across settings is
// structural, not disciplinary: every settings block composes this.
export interface SettingsSectionProps {
  title: string;
  description?: string;
  action?: ReactNode;
  auditHref?: string;
  children?: ReactNode;
}

export function SettingsSection({ title, description, action, auditHref, children }: SettingsSectionProps): JSX.Element {
  return (
    <section className="rounded-hairline border border-border bg-card space-y-6 p-6">
      <Cluster stackBelowSm gap={3}>
        <div>
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
          {auditHref && (
            <Link to={auditHref} className="mt-1 inline-block text-xs font-medium text-primary hover:underline">
              View audit log →
            </Link>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </Cluster>
      {children}
    </section>
  );
}
